import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { Location } from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from '../app/app-routing.module';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, InjectionToken, Injector, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { Drivers } from '@ionic/storage';
import { IonicStorageModule, Storage } from '@ionic/storage-angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicModule, IonicRouteStrategy,  NavController, Platform, ToastController } from '@ionic/angular';

import { EncodeHttpParamsInterceptor } from '../tools/overwrites/CustomHttpEncoder';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { AngularDraggableModule } from 'angular2-draggable';
import{ScreenOrientation} from '@awesome-cordova-plugins/screen-orientation/ngx'
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import{BarcodeScanner}from '@awesome-cordova-plugins/barcode-scanner/ngx'
// import { QRScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { Facebook } from '@awesome-cordova-plugins/facebook/ngx';
import { GooglePlus } from '@awesome-cordova-plugins/google-plus/ngx';
// import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Push } from '@awesome-cordova-plugins/push/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { TapticEngine } from '@awesome-cordova-plugins/taptic-engine/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';//'@ionic-native/app-version/ngx';
import { Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { BackgroundGeolocation } from '@awesome-cordova-plugins/background-geolocation/ngx';
import { NativeAudio } from '@awesome-cordova-plugins/native-audio/ngx';
import { DeviceMotion } from '@awesome-cordova-plugins/device-motion/ngx';
import { LocalNotifications } from '@awesome-cordova-plugins/local-notifications/ngx';
import { Instagram } from '@awesome-cordova-plugins/instagram/ngx';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { PhotoLibrary } from '@awesome-cordova-plugins/photo-library/ngx';
// import { Base64ToGallery } from '@ionic-native/base64-to-gallery/ngx';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';//'@ionic-native/android-permissions/ngx';
// import { Dialogs } from '@ionic-native/dialogs/ngx';
// import { PayPal } from '@ionic-native/paypal/ngx';
import { Stripe } from '@awesome-cordova-plugins/stripe/ngx';
import { Calendar } from '@awesome-cordova-plugins/calendar/ngx';
import { DeviceOrientation } from '@awesome-cordova-plugins/device-orientation/ngx';
import { Media } from '@awesome-cordova-plugins/media/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx'; 
import { ConfigProvider } from 'src/providers/config/config';
import { DarkMode } from 'src/providers/dark-mode/dark-mode';
import { ScreenRotatableService } from 'src/providers/screen-rotatable/screen-rotatable.service';
import { LoaderProvider } from 'src/providers/loader/loader';
import { SessionProvider } from 'src/providers/session/session';
import { AdsProvider } from 'src/providers/ads/ads';
import { DeeplinkProvider } from 'src/providers/deeplink/deeplink';
import { NotificationProvider } from 'src/providers/notification/notification';
import { RequestProvider } from 'src/providers/request/request';
import { SettingsProvider } from 'src/providers/settings/settings';
import { CategoriesProvider } from 'src/providers/categories/categories';
import { GeolocationService } from 'src/providers/geolocation-service/geolocation-service';
import { GoogleMapsProvider } from 'src/providers/google-maps/google-maps';
import { PaymentProvider } from 'src/providers/payment/payment';
import { LocationProvider } from 'src/providers/location/location';
import { LineUpService } from 'src/pages/apps/lineup/services/lineup-service';
import { TournamentService } from 'src/pages/apps/gamer/services/tournament.service';
import { EventDetailsResolver } from 'src/pages/event/details/event-details/event-details-resolver';
import { SharedModule } from 'src/shared/shared.module';
import { AddAthleteModule } from 'src/pages/add-athlete/add-athlete.module';
import { AnmeldungenModule } from 'src/pages/anmeldungen-page/anmeldungen.module';
import { GamerModule } from 'src/pages/apps/gamer/gamer.module';
import { LineupModule } from 'src/pages/apps/lineup/lineup.module';
import { EditAthleteModule } from 'src/pages/edit-athlete-data/edit-athlete.module';
import { EventMainModule } from 'src/pages/event/main/event-main.module';
import { EventsLauncherModule } from 'src/pages/events-launcher/events-launcher.module';
import { InstantPaypalModule } from 'src/pages/instantpaypal/instant-paypal.module';
import { AuthModule } from 'src/pages/login/auth.module';
import { MeModule } from 'src/pages/me/me.module';
import { NearbyModule } from 'src/pages/nearby/nearby.module';
import { NotificationModule } from 'src/pages/notification/notification.module';
import { ParticipantModule } from 'src/pages/participant-page/participant.module';
import { PaymentModule } from 'src/pages/payment-system/payment.module';
import { PictureViewerModule } from 'src/pages/picture-viewer/picture-viewer.module';
import { PremiumModule } from 'src/pages/premium/premium.module';
import { ResultsModule } from 'src/pages/results/results.module';
import { TabsModule } from 'src/pages/tabs/tabs.module';
import { TeamSettingsModule } from 'src/pages/team-settings/team-settings.module';
import { TeamSettingsModalModule } from 'src/pages/team-settings-modal/team-settings-modal.module';
import { TestPageModule } from 'src/pages/test-page/test-page.module';
import { TextPagesModule } from 'src/pages/textPages/text-pages.module';
import { TrackingSettingsModule } from 'src/pages/tracking-settings/tracking-settings.module';
import { WelcomeModule } from 'src/pages/welcome/welcome.module';
import { TrackModule } from 'src/tracker/track-page/track-module';
import { StrackerTrackModule } from 'src/tracker/sencha-tracker/sencha-track-module';
import { LeaderTrackModule } from 'src/tracker/leader-track-page/leader-track-module';
import { EventModule } from 'src/pages/event/event.module';
import { InBrowserModule } from 'src/pages/browser/browser.module';
import { GamerNewModule } from 'src/pages/apps/gamer/pages/new-tou/gamer-new-tou.module';
import { ValueProvider } from 'src/providers/value/value';
import { NearbyMainResolver } from 'src/pages/nearby/main/nearby-main-resolver';
import { IconPipe } from 'src/pipes/icon/icon';
import { TransDatePipe } from 'src/pipes/trans-date/trans-date';
import { TwoNumPipe } from 'src/pipes/two-num/two-num';
import { CoreModule } from 'src/core/core.module';
import { environment } from 'src/environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AngularFireModule } from '@angular/fire/compat';
import { NgswBypassInterceptor } from 'src/interceptors/NgswBypassInterceptor';

export class CustomHammerConfig extends HammerGestureConfig {
  override overrides = {
    'press': { time: 5000 }  //set press delay for 5 second
  }
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    GooglePayButtonModule,
    AngularDraggableModule,
    IonicModule.forRoot({
      swipeBackEnabled: true
    }),
    IonicStorageModule.forRoot({
      name: '__spooortsdb',
      // driverOrder: ['indexeddb', 'websql', 'localstorage']
      driverOrder:[ Drivers.IndexedDB, Drivers.LocalStorage]
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
            deps: [HttpClient]
          }
        }),
        // AdsenseModule.forRoot({
        //   adClient: 'ca-pub-3372584184973915',
        //   adSlot: 3539102521
        // }),
        // ____my own modules
        SharedModule,
        AddAthleteModule,
        AnmeldungenModule,
        GamerModule,
        LineupModule,
        EditAthleteModule,
        EventMainModule,
        EventsLauncherModule,
        InstantPaypalModule,
        AuthModule,
        MeModule,
        NearbyModule,
        NotificationModule,
        ParticipantModule,
        PaymentModule,
        PictureViewerModule,
        PremiumModule,
        ResultsModule,
        TabsModule,
        TeamSettingsModule,
        TeamSettingsModalModule,
        TestPageModule,
        TextPagesModule,
        TrackingSettingsModule,
        WelcomeModule,
        TrackModule,
        StrackerTrackModule,
        LeaderTrackModule,
        EventModule,
        InBrowserModule,
        GamerNewModule,
        CoreModule,
        AngularFireModule.initializeApp(environment.firebase),
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: true,
          registrationStrategy: 'registerWhenStable:30000',
        }),
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncodeHttpParamsInterceptor,
      multi: true
    },
    { provide: ErrorHandler, useClass: ErrorHandler },
    StatusBar,
    SplashScreen,
    Camera,
    Device,
    Facebook,
    Geolocation,
    GooglePlus,
    // InAppBrowser,
    Push,
    SocialSharing,
    TapticEngine,
    AppVersion,
    Deeplinks,
    BackgroundGeolocation,
    NativeAudio,
    DeviceMotion,
    LocalNotifications,
    Instagram,
    Diagnostic,
    PhotoLibrary,
    File,
    HTTP,
    // Transfer,
    // Base64ToGallery,
    AndroidPermissions,
    // Dialogs,
    // PayPal,
    Stripe,
    Calendar,
    // QRScanner,
    BarcodeScanner,
    ScreenOrientation,
    DeviceOrientation,
    Media,
    // ____ services
    ConfigProvider,
    DarkMode,
    SessionProvider,
    ScreenRotatableService,
    LoaderProvider,
    AdsProvider,
    DeeplinkProvider,
    NotificationProvider,
    RequestProvider,
    SettingsProvider,
    CategoriesProvider,
    GeolocationService,
    GoogleMapsProvider,
    PaymentProvider,
    LocationProvider,
    LineUpService,
    TournamentService,
    EventDetailsResolver,
    ValueProvider,
    NearbyMainResolver,
    IconPipe,
    // TransDatePipe,
    DatePipe,
    TwoNumPipe,
    Location,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NgswBypassInterceptor,
      multi: true
    }

    // _____

    
  ],
  
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
    // private statusBar: StatusBar
    // let status bar overlay webview
    // this.statusBar.overlaysWebView(true);
    // set status bar to white
    // this.statusBar.backgroundColorByHexString('#ffffff');
  }
}
export let AppInjector: Injector;

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
